<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-brand" animation="fadeInRight">
      <div slot="title">Add Brand</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Brand Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addBrand['brand']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">AFF Program</div>
            <div class="col-lg-9">
              <v-select
                v-model="addBrand['affiliateProgram']"
                :options="affCompanies"
                index="id"
                label="name"
                placeholder="Select an affiliate program"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">License</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addBrand['license']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Note</div>
            <div class="col-lg-9">
              <input type="note" name="img" accept="image/*" class="form-control" v-model="addBrand['note']">
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveBrand">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Brands</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-brand">Add Brand</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Brands/Filters'
import List from './Brands/List'
import axios from 'axios'
import { BRANDS_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'

const brandAddDefaults = {
  brand: '',
  affiliateProgram: '',
  license: '',
  logo: ''
}

export default {
  data () {
    return {
      addBrand: {...brandAddDefaults},
      affCompanies: []
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mounted () {
    document.title = 'Brands :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.getAffCompany()
  },
  components: {
    filters: Filters,
    list: List,
    modalForm: Modal
  },
  methods: {
    async saveBrand () {
      try {
        const addBrand = {...this.addBrand}
        if (!addBrand.brand) {
          this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
          return
        }
        let resp = await axios.post('/advertisers/brands', addBrand)
        $('#add-brand').modal('hide')
        this.$store.commit(BRANDS_SET, [...this.$store.state.brands, resp.data])
        this.$toastr.success('Brand added successfully', 'Brilliant stuff lad')
      } catch (e) {
        const msg = e.response ? e.response.data.msg : 'Not so great is it...'
        this.$toastr.error(e, msg)
      }
      // Reset form to defaults
      Object.keys(brandAddDefaults).forEach(k => {
        this.$set(this.addBrand, k, brandAddDefaults[k])
      })
    },
    async getAffCompany () {
      try {
        let resp = await axios.get('/advertisers/affiliate-companies')
        this.affCompanies = resp.data
      } catch (e) {
        console.error(e, 'Error fetching AffCompany')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brands.vue